import { useRecoilValue } from "recoil";
import workOrderValueAtom from "../atoms/workOrderValueAtom";
import estimateImageAtom from "../atoms/estimateImageAtom";
import { btnRound, btnSmall } from "../utils/style";
import arrowBlack from '../assets/icons/arrow_black.png'
import formatNumberToUs from "../helper_functions/formatNumberToUs";
import returnDiscountedAmount from "../helper_functions/returnDiscountedAmount";
import returnDiscount from "../helper_functions/returnDiscount";
import { useState } from "react";
import ConfirmationModal from "./ConfirmationModal";
import { url } from "../utils/config";
import appointmentDetailsAtom from "../atoms/appointmentDetailsAtom";

function PreviewEstimate({ setOrderState, createWorkOrder }) {
    const workOrder = useRecoilValue(workOrderValueAtom)
    const appointmentDetails = useRecoilValue(appointmentDetailsAtom);
    const estimateImage = useRecoilValue(estimateImageAtom);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const technicianCost = appointmentDetails.technicianHourlyCost
    const defaultTaxCost = appointmentDetails.taxRatePercent

    function calculateTotalMinutes() {
        let totalMinutes = 0;

        workOrder?.serviceList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
        workOrder?.materialList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
        workOrder?.otherList?.data?.forEach(data => totalMinutes += +data.estimatedTime);

        // console.log(totalMinutes)
        var result = (totalMinutes / 60);
        return result;
    }

    // console.log('calculateTotalDiscount', calculateTotalDiscount(workOrder,technicianCost))
    function calculateTotalHours() {

        var totalMinutes = 0;

        workOrder?.serviceList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
        workOrder?.materialList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
        workOrder?.otherList?.data?.forEach(data => totalMinutes += +data.estimatedTime);

        let mins = totalMinutes;
        let hours = Math.floor(mins / 60); // Get the number of full hours
        let minutes = mins % 60; // Get the remaining minutes
        if (hours === 0) {
            return `${minutes} mins`;
        } else {
            return `${hours} hr ${minutes} mins`;
        }

    }


    function calculateMaterialCost() {
        var totalCost = 0;
        workOrder.materialList.data.forEach(mat => { totalCost += +returnDiscountedAmount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
        return totalCost
    }

    function calculateBundleCost() {
        var totalCost = 0;
        workOrder.serviceBundle.data.forEach(bundle => { totalCost += +returnDiscountedAmount({ cost: bundle.cost, discount: bundle.discount, discountType: bundle.discountType }) });
        return totalCost
    }

    function calculateServiceCost() {
        var totalCost = 0;
        workOrder.serviceList.data.forEach(service => service.costType === 'Fixed' && (totalCost += +returnDiscountedAmount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
        return totalCost
    }

    const convertToDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${month}-${day}-${year}`;
    }


    function calculateMaterialCostDiscount() {
        var totalCost = 0;
        workOrder.materialList.data.forEach(mat => { totalCost += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
        return totalCost
    }

    function calculateServiceCostDiscount() {
        var totalCost = 0;
        workOrder.serviceList.data.forEach(service => service.costType === 'Fixed' && (totalCost += +returnDiscount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
        return totalCost
    }

    function calculateBundleCostDiscount() {
        var totalCost = 0;
        workOrder.serviceBundle.data.forEach(mat => { totalCost += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
        return totalCost
    }


    function calculateTotalDiscount() {
        const data = calculateMaterialCostDiscount() + calculateBundleCostDiscount() + calculateServiceCostDiscount()
        return Number(data).toFixed(2)
    }


    return (
        <div className="min-h-screen bg-gray-50 pb-24">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b z-10 py-3 px-4">
                <div className="flex items-center">
                    <button className={btnRound} onClick={() => setOrderState('create')}>
                        <img src={arrowBlack} alt="back" />
                    </button>
                    <h2 className="ml-2 text-lg font-semibold text-gray-900">Preview Estimate</h2>
                </div>
            </div>

            {/* Content */}
            <div className="p-4 space-y-4">
                {/* Service Bundle Section */}
                {workOrder.serviceBundle?.data?.length > 0 && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="text-sm font-semibold text-gray-900">Service Bundle</h3>
                        </div>
                        <div className="divide-y">
                            {workOrder.serviceBundle.data.map((bundle, index) => (
                                <div key={index} className="px-4 py-3 flex justify-between items-center">
                                    <span className="text-sm text-gray-700 capitalize">{bundle.name}</span>
                                    <span className="text-sm font-medium text-gray-900">
                                        ${formatNumberToUs(returnDiscountedAmount({ cost: bundle.cost, discount: bundle.discount, discountType: bundle.discountType }))}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Services Section */}
                {workOrder.serviceList?.data?.length > 0 && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="text-sm font-semibold text-gray-900">Services</h3>
                        </div>
                        <div className="divide-y">
                            {workOrder.serviceList.data.map((service, index) => (
                                <div key={index} className="px-4 py-3 flex justify-between items-center">
                                    <span className="text-sm text-gray-700">{service.name}</span>
                                    <span className="text-sm text-gray-500">
                                        {service.costType === 'Fixed' && '$'}
                                        {service.estimatedTime || returnDiscountedAmount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })?.toFixed(2)}
                                        {service.costType === 'Hourly' && ' mins'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Others Section */}
                {workOrder.otherList?.data?.length > 0 && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="text-sm font-semibold text-gray-900">Other Services</h3>
                        </div>
                        <div className="divide-y">
                            {workOrder.otherList.data.map((other, index) => (
                                <div key={index} className="px-4 py-3 flex justify-between items-center">
                                    <span className="text-sm text-gray-700">{other.name}</span>
                                    <span className="text-sm text-gray-500">{other.estimatedTime} mins</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Parts Section */}
                {workOrder.materialList?.data?.length > 0 && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="text-sm font-semibold text-gray-900">Parts</h3>
                        </div>
                        <div className="divide-y">
                            {workOrder.materialList.data.map((material, index) => (
                                <div key={index} className="px-4 py-3">
                                    <div className="flex justify-between items-center mb-1">
                                        <span className="text-sm text-gray-700">{material.name}</span>
                                        <span className="text-sm font-medium text-gray-900">${formatNumberToUs(returnDiscountedAmount({ cost: material.cost, discount: material.discount, discountType: material.discountType }))}</span>
                                    </div>
                                    <div className="text-xs text-gray-500">Estimated Time: {material.estimatedTime} mins</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Summary Section */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                    <div className="px-4 py-3 border-b">
                        <h3 className="text-sm font-semibold text-gray-900">Summary</h3>
                    </div>
                    <div className="p-4 space-y-3">
                        <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">Total Estimated Time</span>
                            <span className="text-sm font-medium text-gray-900">{calculateTotalHours()}</span>
                        </div>

                        {workOrder.materialList?.data?.length > 0 && (
                            <div className="flex justify-between items-center">
                                <span className="text-sm text-gray-600">Total Parts Cost</span>
                                <span className="text-sm font-medium text-gray-900">${formatNumberToUs(calculateMaterialCost())}</span>
                            </div>
                        )}

                        {workOrder.serviceBundle?.data?.length > 0 && (
                            <div className="flex justify-between items-center">
                                <span className="text-sm text-gray-600">Total Service Bundle Cost</span>
                                <span className="text-sm font-medium text-gray-900">${formatNumberToUs(calculateBundleCost())}</span>
                            </div>
                        )}

                        <div className="pt-2 border-t">
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Labor Cost (${technicianCost}/hr)</span>
                                <span className="text-sm font-medium text-gray-900">
                                    ${formatNumberToUs((calculateTotalMinutes() * technicianCost).toFixed(2))}
                                </span>
                            </div>
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Subtotal</span>
                                <span className="text-sm font-medium text-gray-900">
                                    ${formatNumberToUs(Number((calculateTotalMinutes() * technicianCost).toFixed(2)) + Number(calculateMaterialCost()) + Number(calculateBundleCost()) + Number(calculateServiceCost()))}
                                </span>
                            </div>
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Discount</span>
                                <span className="text-sm font-medium text-gray-900">
                                    ${Number(calculateTotalDiscount()).toFixed(2)}
                                </span>
                            </div>
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Sales Tax (${defaultTaxCost}%)</span>
                                <span className="text-sm font-medium text-gray-900">
                                    ${formatNumberToUs((calculateMaterialCost()) * (defaultTaxCost / 100))}
                                </span>
                            </div>
                            <div className="flex justify-between items-center pt-2 border-t">
                                <span className="text-base font-semibold text-gray-900">Final Cost</span>
                                <span className="text-base font-semibold text-customOne">
                                    ${formatNumberToUs(Number((calculateTotalMinutes() * technicianCost).toFixed(2)) + Number(calculateMaterialCost()) + Number(calculateBundleCost()) + Number(calculateServiceCost()) + Number((calculateMaterialCost()) * (defaultTaxCost / 100)))}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Image Previews */}
                {(workOrder.uploadedImages?.length > 0 || estimateImage.length > 0) && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="text-sm font-semibold text-gray-900">Images</h3>
                        </div>
                        <div className="p-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
                            {workOrder.uploadedImages?.map((imageName, index) => (
                                <div key={`server-${index}`} className="relative group">
                                    <img
                                        src={`${url}/estimate_images/${imageName}`}
                                        alt={`uploaded-${index}`}
                                        className="w-full h-32 object-cover rounded-sm"
                                    />
                                </div>
                            ))}
                            {estimateImage.length > 0 && estimateImage.map((image, index) => (
                                <div key={index}>
                                    <img
                                        src={URL.createObjectURL(image)}
                                        alt={`preview-${index}`}
                                        className="w-full h-32 object-cover rounded"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Completion Details */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                    <div className="px-4 py-3 border-b">
                        <h3 className="text-sm font-semibold text-gray-900">Completion Details</h3>
                    </div>
                    <div className="p-4 space-y-3">
                        <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">Estimated Completion Date</span>
                            <span className="text-sm font-medium text-gray-900">{convertToDate(workOrder.estimatedDate)}</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">Estimated Completion Time</span>
                            <span className="text-sm font-medium text-gray-900">{workOrder.estimatedTime ?
                                new Date('1970-01-01T' + workOrder.estimatedTime)
                                    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
                                : ''
                            }</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Actions */}
            <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4">
                <button
                    className={btnSmall}
                    onClick={() => {
                        if (workOrder.id) {
                            setShowConfirmModal(true);
                        } else {
                            createWorkOrder();
                        }
                    }}
                >
                    {`${workOrder.id ? 'Update' : 'Send'} Estimate`}
                </button>
            </div>

            {/* Confirmation Modal */}
            {showConfirmModal && <ConfirmationModal
                header={'Modify'}
                body={'Are you sure you want to modify the estimate?'}
                cancelHandler={setShowConfirmModal}
                confirmHandler={createWorkOrder}
            />}
        </div>
    )
}

export default PreviewEstimate;